import * as tslib_1 from "tslib";
import firebase from "firebase/app";
import { auth as authFB } from "@/helpers/firebase";
import { Mutation } from "vuex-class";
import { Vue, Component } from "vue-property-decorator";
let widget = class widget extends Vue {
    siGoogle() {
        this.setPageState("loading");
        authFB.signInWithRedirect(new firebase.auth.GoogleAuthProvider());
    }
    siFacebook() {
        this.setPageState("loading");
        authFB.signInWithRedirect(new firebase.auth.FacebookAuthProvider());
    }
};
tslib_1.__decorate([
    Mutation("nav/setState")
], widget.prototype, "setPageState", void 0);
widget = tslib_1.__decorate([
    Component({})
], widget);
export default widget;
